import React, {useLayoutEffect, useRef, useState} from 'react';

const LocationMap = () => {
    const mapRef = useRef(null);
    const [mapBoundingRect, setMapBoundingRect] = useState(null);

    useLayoutEffect(() => {
        if (!mapBoundingRect && mapRef.current?.getBoundingClientRect()) {
            setMapBoundingRect(mapRef.current?.getBoundingClientRect());
        }
    }, [mapBoundingRect]);

    return (
        <div className="col-md-6" ref={mapRef}>
            {mapBoundingRect && (
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3390.060074334813!2d-106.3380821!3d31.823356999999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x86e75ab2631128c3%3A0x6f44ffe72efbbc2f!2sButterfield%20Trail%20Golf%20Club!5e0!3m2!1sen!2sus!4v1770251333589!5m2!1sen!2sus"
                    style={{ border: 0, width: mapBoundingRect.width, height: 350 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Butterfield Trail Golf Club - Google Map"
                />
            )}
        </div>
    );
};

export default LocationMap;